<app-sponsor-banner-signal [location]="'article-top'" [sponsor_key]="'article-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner-signal>

@if (data && data.iframe_data) {
    <app-iframe [isChildComponent]="true" [enhancedArticleProps]="data.iframe_data" (closeEvent)="close($event)"> </app-iframe>
}

@if (schedule_entries.length) {
    <div class="related-entries">
        @for (item of schedule_entries; track item; let i = $index) {
            <app-scheduled-entry
                (click)="openScheduleEntry(item.id)"
                [margin_bottom]="i === schedule_entries.length - 1 ? '0em' : '1em'"
                [entry]="item"
                [attr.data-schedule-entry-id]="item.id"
            ></app-scheduled-entry>
        }
    </div>
}

@if (matches.length) {
    <section class="scroll-section matches">
        @for (match of matches; track match) {
            <app-tennis-match
                [match_data]="match"
                [round]="match.round"
                [display_match_status]="true"
                [display_tour_name]="false"
                (openMatchDetails)="openMatchDetails($event)"
                (openMatchChat)="openMatchChat($event)"
                [attr.data-match-id]="match.id"
                [show_comment]="true"
            ></app-tennis-match>
        }
    </section>
}

@if (article_players && article_players.length > 0) {
    <div class="tagged-players">
        @for (player of article_players; track player) {
            <div>
                <div class="article-player">
                    <app-image
                        style="cursor: pointer"
                        (click)="openDialog(player)"
                        [display_flag]="true"
                        [app_country_flag_width]="'1em'"
                        [player]="player"
                        [margin]="'0'"
                        [width]="'52px'"
                        [height]="'52px'"
                    >
                    </app-image>
                    <div style="margin-left: 15px">{{ player.first_name }} {{ player.last_name }}</div>
                </div>
            </div>
        }
    </div>
}

<div class="share-container">
    <div class="item">
        {{ getArticlePublicationDate() }}
    </div>
    <div class="buttons-container">
        <button mat-button (click)="shareArticle()">
            <mat-icon>share</mat-icon>
            <app-app-string class="label" [key_name]="'articles.share'"></app-app-string>
        </button>
        <!-- <button mat-flat-button (click)="shareArticle()">
    <img src="assets/forward.png" alt="likes" style="margin-right: 0.4em;" />
    <span>
      <app-app-string class="label" [key_name]="'articles.share'"></app-app-string>
    </span>
  </button> -->
        <!-- <button mat-flat-button (click)="likeArticle()" [ngStyle]="likedArticle()" >
  <img src="assets/liked1.png" alt="likes" style="margin-right: 0.4em;"
    *ngIf="article && article.current_fan_liked" />
  <img src="assets/like.png" alt="likes" style="margin-right: 0.4em;"
    *ngIf="article && !article.current_fan_liked" />
  <span style="margin-right: 0.4em;">{{ getArticleLikes() }}</span>
</button> -->
    </div>
</div>

<div class="comments-container">
    <div class="login-container" [ngStyle]="{ 'justify-content': isLoggedIn() && !loading ? 'flex-start' : 'center' }">
        @if (loading) {
            <app-loading-indicator type="circle"></app-loading-indicator>
        }
        @if (isLoggedIn() && !loading && captchaSuccess) {
            <div class="comment-box">
                <img [src]="loggedUserProfileImage" alt="profileImg" />
                <div class="input-wrapper">
                    <textarea
                        type="text"
                        [placeholder]="appStringAPI.getAppString('articles.comments.placeholder')"
                        [formControl]="comment"
                        maxlength="255"
                        (keydown.enter)="publish()"
                    ></textarea>
                </div>
                @if (isLoggedIn() && !loading) {
                    <div class="send-area">
                        <button mat-icon-button [disabled]="comment.value.trim().length === 0" (click)="publish()"><mat-icon>send</mat-icon></button>
                        <div class="char-counter">{{ comment.value.length }}/255</div>
                    </div>
                }
            </div>
        }

        @if (isLoggedIn() && !loading && !captchaSuccess) {
            <div class="captcha">
                <div class="container-fluid py-3">
                    <form #form="ngForm">
                        <div class="row mt-3">
                            <div class="captcha-form col-sm-12 mb-2">
                                @if (verifying_captcha) {
                                    <mat-spinner [diameter]="30" style="margin: 0.5rem"></mat-spinner>
                                }
                                @if (!verifying_captcha) {
                                    <button mat-flat-button type="button" class="btn btn-sm btn-primary" (click)="verifyRecaptcha(form)">Verify</button>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        }

        @if (!isLoggedIn() && !loading) {
            <div class="nested-login-prompt">
                <div class="login-message">
                    <mat-icon>account_circle</mat-icon>
                    <span>
                        <app-app-string class="label" [key_name]="'articles.auth'"></app-app-string>
                    </span>
                </div>

                <div id="nested-loginButton"></div>
            </div>
        }
    </div>

    @for (comment of comments; track comment) {
        <div class="comments">
            <div style="display: flex; flex-direction: column">
                <div class="profile-img">
                    <img [src]="getAvatarUrl(comment)" (error)="onImgError($event)" alt="profileImg" />
                </div>
                <div></div>
            </div>
            <div class="comment-content">
                <div class="name">
                    <div style="font-weight: 900">{{ getFanName(comment) }}</div>
                    <div class="like">
                        <div style="height: 100%">
                            <!-- <button mat-icon-button *ngIf="!comment.current_fan_liked" (click)="likeArticleComment(comment.id)"><mat-icon>thumb_up</mat-icon></button>
              <button mat-icon-button *ngIf="!comment.current_fan_liked" (click)="dislikeArticleComment(comment.id)"><mat-icon>thumb_down</mat-icon></button> -->
                            <button
                                mat-icon-button
                                (click)="toggleLikeComment(comment)"
                                [attr.aria-pressed]="!!comment.current_fan_liked"
                                [attr.aria-label]="comment.current_fan_liked ? 'Unlike comment' : 'Like comment'"
                            >
                                <mat-icon [ngClass]="{ liked: !!comment.current_fan_liked }">
                                    {{ comment.current_fan_liked ? 'thumb_up' : 'thumb_up_off_alt' }}
                                </mat-icon>
                            </button>
                        </div>
                        <div [ngStyle]="{ visibility: comment?.likes !== 0 ? 'visible' : 'hidden' }" class="number-likes">{{ comment.likes }}</div>
                    </div>
                </div>
                <div class="content">{{ comment.content }}</div>
            </div>
        </div>
    }

    <div class="banner">
        <div style="width: 90%; text-align: center">
            @if (data.card) {
                @if (video_ad_sponsor) {
                    <app-rotating-sponsors [video_ad_sponsor]="video_ad_sponsor" [card]="data.card" [default_aspect_ratio]="'9:1'"></app-rotating-sponsors>
                } @else {
                    <app-rotating-sponsors [default_aspect_ratio]="'9:1'" [card]="data.card"></app-rotating-sponsors>
                }
            }
        </div>
    </div>
</div>
